export default [
  "Starter",
  "Route 101 (Gras)",
  "Route 103 (Gras)",
  "Route 102 (Gras)",
  "Route 104 (Gras)",
  "Blütenburgwald (Gras)",
  "Metarost City (Fossil-Geschenk)",
  "Route 116 (Gras)",
  "Metaflurtunnel (Höhle)",
  "Granithöhle (Höhle)",
  "Route 105 (Surfen)",
  "Route 106 (Angeln / Surfen)",
  "Faustauhaven (Angeln)",
  "Route 107 (Surfen)",
  "Route 108 (Surfen)",
  "Route 109 (Surfen)",
  "Blütenburg City",
  "Graphitport City (Angeln)",
  "Route 110 (Gras)",
  "Malvenfroh City (Geschenk)",
  "Route 117 (Gras)",
  "Route 111 (Gras)",
  "Route 112 (Gras)",
  "Feuriger Pfad(Höhle)",
  "Route 113 (Gras)",
  "Route 114 (Gras)",
  "Meteorhöhle (Höhle)",
  "Laubwechselfeld (Gras)",
  "Route 115 (Gras)",
  "Route 118 (Gras / Angeln)",
  "Route 119 (Gras)",
  "Wetterinstitut (Geschenk: Formeo)",
  "Route 120 (Gras)",
  "Route 121 (Gras)",
  "Route 122 (Surfen)",
  "Pyroberg (Höhle)",
  "Route 123 (Gras)",
  "Seegrasulb City (Angeln)",
  "Route 124 (Surfen / Angeln)",
  "Route 125 (Angeln)",
  "Route 126 (Angeln)",
  "Xeneroville (Angeln)",
  "Route 127 (Surfen / Angeln)",
  "Route 128 (Surfen / Angeln)",
  "Route 129 (Angeln)",
  "Route 130 (Angeln)",
  "Route 131 (Angeln)",
  "Route 132 (Surfen)",
  "Route 133 (Surfen)",
  "Route 134 (Surfen)",
  "Seewoge Malvenfroh (Angeln)",
  "Siegesstraße (Höhle)",
  "Pokémon-Liga (Angeln)",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];